module.exports = __webpack_public_path__ + "assets/img/c6ab58de3333fe46c76c382dcb783b2b.svg";